export function formatTeacherFull(teacher, fallback = 'Без имени') {
    if (!teacher) return fallback

    const fullName = `${teacher.lastname || ''} ${teacher.firstname || ''} ${
        teacher.patronymic || ''
    }`.trim()

    return fullName || fallback
}
